<template>
    <EditFiliereNiveauMatiere />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import EditFiliereNiveauMatiere from "@/components/FiliereNiveauMatiere/EditFiliereNiveauMatiere..vue";
  
    export default defineComponent({
      name: "EditFiliereNiveauMatierePage",
      components: {
        
        EditFiliereNiveauMatiere,
      },
    });
  </script>